module.exports = __webpack_public_path__ + "static/media/1-1_Embossing.8a0b49fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/1-1_Embossing.jpg
// module id = 563
// module chunks = 0